const state = {
  lang: localStorage.getItem("language")
}

const getters = {
  currentlang(state) {
    return state.lang
  }
}

const actions = {
  setCurrentLang(context, payload) {
    context.commit('setCurrentLang', payload)
  }
}

const mutations = {
  setCurrentLang(state, payload) {
    state.lang = payload
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
}
